
        window.addEventListener('load', function(){

            // obtain plugin
            var cc = initCookieConsent();

            // run plugin with your configuration
            cc.run({
                current_lang: 'es',
                autoclear_cookies: true,                   // default: false
                page_scripts: true,                        // default: false

                // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
                // delay: 0,                               // default: 0
                auto_language: 'browser',                      // default: null; could also be 'browser' or 'document'
                // autorun: true,                          // default: true
                force_consent: true,                   // default: false
                hide_from_bots: true,                   // default: true
                // remove_cookie_tables: false             // default: false
                // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
                // cookie_expiration: 182,                 // default: 182 (days)
                // cookie_necessary_only_expiration: 182   // default: disabled
                // cookie_domain: location.hostname,       // default: current domain
                // cookie_path: '/',                       // default: root
                // cookie_same_site: 'Lax',                // default: 'Lax'
                // use_rfc_cookie: false,                  // default: false
                // revision: 0,                            // default: 0

                onFirstAction: function(user_preferences, cookie){
                    // callback triggered only once on the first accept/reject action
                },

                  gui_options: {
        consent_modal: {
            layout: 'cloud',               // box/cloud/bar
            position: 'bottom center',     // bottom/middle/top + left/right/center
            transition: 'slide',           // zoom/slide
            swap_buttons: false            // enable to invert buttons
        },
        settings_modal: {
            layout: 'box',                 // box/bar
            // position: 'left',           // left/right
            transition: 'slide'            // zoom/slide
        }
    },

                onAccept: function (cookie) {
                    // callback triggered on the first accept/reject action, and after each page load
                },

                onChange: function (cookie, changed_categories) {
                    // callback triggered when user changes preferences after consent has already been given
                },


                languages: {
                                      'es': {
                        consent_modal: {
                            title: 'Utilizamos cookies',
                            description: 'Usamos cookies para mejorar su experiencia de navegación en nuestra web, para mostrarle contenidos personalizados y para analizar el tráfico en nuestra web. <button type="button" data-cc="c-settings" class="cc-link">Déjame elegir</button>',
                            primary_btn: {
                                text: 'Aceptar',
                                role: 'accept_all'              // 'accept_selected' or 'accept_all'
                            },
                            secondary_btn: {
                                text: 'Rechazar',
                                role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                            }
                        },
                        settings_modal: {
                            title: 'Preferencias de cookies',
                            save_settings_btn: 'Guardar configuración',
                            accept_all_btn: 'Aceptar',
                            reject_all_btn: 'Rechazar',
                            close_btn_label: 'Cerrar',
                            cookie_table_headers: [
                                {col1: 'Nombre'},
                                {col2: 'Dominio'},
                                {col3: 'Expiración'},
                                {col4: 'Descripción'}
                            ],
                            blocks: [
                                {
                                    title: 'Uso de cookies 📢',
                                    description: 'Utilizamos cookies para asegurar las funcionalidades básicas del sitio web y para mejorar su experiencia en línea. Puede elegir para cada categoría optar por participar o no participar cuando lo desee. Para obtener más detalles sobre las cookies y otros datos confidenciales, lea la <a href="#" class="cc-link">política de privacidad</a> completa.'
                                }, {
                                    title: 'Cookies estrictamente necesarias',
                                    description: 'Estas cookies son esenciales para el correcto funcionamiento de mi sitio web. Sin estas cookies, el sitio web no funcionaría correctamente.',
                                    toggle: {
                                        value: 'necessary',
                                        enabled: true,
                                        readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                                    }
                                }, {
                                    title: 'Cookies de rendimiento y análisis',
                                    description: 'Estas cookies permiten que el sitio web recuerde las elecciones que ha realizado en el pasado',
                                    toggle: {
                                        value: 'analytics',     // your cookie category
                                        enabled: false,
                                        readonly: false
                                    },
                                    cookie_table: [             // list of all expected cookies
                                        {
                                            col1: '^_ga',       // match all cookies starting with "_ga"
                                            col2: 'google.com',
                                            col3: '2 años',
                                            col4: 'Se usa para distinguir a los usuarios.',
                                            is_regex: true
                                        },
                                        {
                                            col1: '_gid',
                                            col2: 'google.com',
                                            col3: '1 día',
                                            col4: 'Se usa para distinguir a los usuarios.',
                                        },
                                        {
                                            col1: 'klaviyoOnsite',       // match all cookies starting with "_ga"
                                            col2: 'klaviyo.com',
                                            col3: 'Permanente',
                                            col4: 'Esta cookie se utiliza para gestionar la lista de correo, si el visitante se ha subscrito a alguna newsletter o a algún blog.',
                                        },
                                    ]
                                }, {
                                    title: 'Cookies publicitarias y de orientación',
                                    description: 'Estas cookies recopilan información sobre cómo usa el sitio web, qué páginas visitó y en qué enlaces hizo clic. Todos los datos son anónimos y no se pueden usar para identificarte',
                                    toggle: {
                                        value: 'targeting',
                                        enabled: false,
                                        readonly: false
                                    }
                                }, {
                                    title: 'Más información',
                                    description: 'Para cualquier consulta en relación con nuestra política de cookies y sus opciones, <a class="cc-link" href="https://capitandenim.com/pages/contact">contáctanos</a>.',
                                }
                            ]
                        }
                    }
                }
            });
        });
